module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "shaded mx-4 my-4",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.next.apply(null, arguments)
      }
    }
  }, [(_vm.isDisabled) ? _c('div', {
    staticClass: "form-error-msg"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("* You need to review the mandatory fields before you can save.")])]) : _vm._e(), _vm._v(" "), (!_vm.getSelectedPerson) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-1 py-2"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "submit",
      "value": "Next",
      "disabled": _vm.$v.form.$invalid || _vm.$v.businessTypeId.$invalid
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row mb-0"
  }, [(_vm.showExistingAgentSelector) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('agent-existing-selector', {
    on: {
      "valueChanged": _vm.useExistingOrCreateChanged
    },
    model: {
      value: (_vm.form.saveAndSend),
      callback: function($$v) {
        _vm.$set(_vm.form, "saveAndSend", $$v)
      },
      expression: "form.saveAndSend"
    }
  })], 1) : (!this.getSelectedPerson) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('agent-virtual-or-invite', {
    on: {
      "agentType": _vm.agentType
    },
    model: {
      value: (_vm.form.saveAndSend),
      callback: function($$v) {
        _vm.$set(_vm.form, "saveAndSend", $$v)
      },
      expression: "form.saveAndSend"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "lightest bg-medium text-center fs-large p-2 mb-4 bold"
  }, [_vm._v("\n            OTA\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "shaded",
    class: _vm.getSelectedPerson ? '' : 'panel'
  }, [_c('div', {
    staticClass: "form-group row mb-1"
  }, [(_vm.getSelectedPerson) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('span', [_vm._v("Profile")]), _vm._v(" "), (_vm.form.isLoading) ? _c('div', {
    staticClass: "d-flex justify-content-right align-items-center position-relative"
  }, [_c('loader')], 1) : (!_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "d-flex justify-content-right align-items-center position-relative"
  }, [(_vm.passedForm.inviteStatus == 5) ? _c('button', {
    staticClass: "btn blue mr-2",
    on: {
      "click": function($event) {
        return _vm.callInviteAgent(_vm.passedForm)
      }
    }
  }, [_vm._v("Connect")]) : _vm._e(), _vm._v(" "), (_vm.passedForm.inviteStatus == 0) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.disabledForInviteOfflineAgent && 'You need to provide a valid e-mail. Ex: \'user@domain.com\'  '),
      expression: "disabledForInviteOfflineAgent && 'You need to provide a valid e-mail. Ex: \\'user@domain.com\\'  '"
    }]
  }, [_c('button', {
    staticClass: "btn blue mr-2",
    attrs: {
      "disabled": _vm.disabledForInviteOfflineAgent
    },
    on: {
      "click": function($event) {
        return _vm.callInviteAgent(_vm.passedForm)
      }
    }
  }, [_vm._v("Invite")])]) : _c('span', {
    staticClass: "btn cursor-default radius-stadium",
    class: _vm.peopleInviteStatus(_vm.passedForm).colorClass
  }, [_vm._v(_vm._s(_vm.peopleInviteStatus(_vm.passedForm).label))]), _vm._v(" "), (_vm.listActions.length > 0) ? _c('three-dots', {
    attrs: {
      "items": _vm.listActions
    },
    on: {
      "input": _vm.selectedConnectionAction
    }
  }) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 input-min-height"
  }, [(_vm.useExistingAgent) ? _c('div', {
    staticClass: "full"
  }, [_vm._m(0), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.availableAgents,
      "label": "brandName",
      "placeholder": "Select an agent"
    },
    on: {
      "input": _vm.agentSelected
    },
    model: {
      value: (_vm.existingSelectedAgent),
      callback: function($$v) {
        _vm.existingSelectedAgent = $$v
      },
      expression: "existingSelectedAgent"
    }
  })], 1) : _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.brandName),
      expression: "form.brandName"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.passedForm.isOTA
    },
    domProps: {
      "value": (_vm.form.brandName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "brandName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.brandName.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.brandName.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.brandName.minLength) ? _c('span', [_vm._v("Name must have at least 2 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 input-min-height"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Code\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mb-1"
  }, [_c('div', {
    staticClass: "col-sm-6 input-min-height"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Email "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.email),
      expression: "form.email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.disableEditEmail
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "keyup": function($event) {
        _vm.emailChanged = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.email.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.email.email) ? _c('span', [_vm._v("Must be a valid email.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 input-min-height"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Phone\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.phone.$invalid) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v("This must be a phone number.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mb-1 input-min-height"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getChannelSalesList && !_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Business Type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getChannelSalesList,
      "placeholder": "Pick a sales channel",
      "label": "description"
    },
    on: {
      "input": _vm.updateRole
    },
    model: {
      value: (_vm.selectedRole),
      callback: function($$v) {
        _vm.selectedRole = $$v
      },
      expression: "selectedRole"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedRole && _vm.selectedRole.id === 100) ? _c('div', {
    staticClass: "col-sm-6 input-min-height"
  }, [_c('label', [_vm._v("\n\t\t\t\t\t\t\t\t\t\tCustom Business Type "), (_vm.isRequiredToChooseCustomBusinessType) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.getCustomBusinessTypes.length > 0) ? _c('v-select', {
    attrs: {
      "options": _vm.getCustomBusinessTypes,
      "placeholder": "Select a custom business type",
      "label": "name"
    },
    on: {
      "input": function($event) {
        return _vm.customBusinessTypeChanged($event)
      }
    },
    model: {
      value: (_vm.form.businessType),
      callback: function($$v) {
        _vm.$set(_vm.form, "businessType", $$v)
      },
      expression: "form.businessType"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getCustomBusinessTypes.length === 0) ? _c('button', {
    staticClass: "btn btn-xs mt-1",
    on: {
      "click": _vm.addCustomBusinessType
    }
  }, [_vm._v("Add Custom Business Type")]) : _vm._e(), _vm._v(" "), (_vm.$v.businessTypeId.$invalid) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v("You must " + _vm._s(_vm.getCustomBusinessTypes.length > 0 ? 'select' : 'add') + " a custom business type.")])]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), (!_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "col-sm-12 mb-5"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Notes "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("(internal note)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), (!_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "mb-5"
  }, [_c('h5', [_vm._v("Contacts")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Financial Email\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactFinancialEmail),
      expression: "form.contactFinancialEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactFinancialEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactFinancialEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Financial Phone\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactFinancialPhone),
      expression: "form.contactFinancialPhone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactFinancialPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactFinancialPhone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Sales Email\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactSalesEmail),
      expression: "form.contactSalesEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactSalesEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactSalesEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Sales Phone\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactSalesPhone),
      expression: "form.contactSalesPhone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactSalesPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactSalesPhone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    General Email\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactOthersEmail),
      expression: "form.contactOthersEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactOthersEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactOthersEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    General Phone\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactOthersPhone),
      expression: "form.contactOthersPhone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactOthersPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactOthersPhone", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("Billing Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mb-1"
  }, [_c('div', {
    staticClass: "col-sm-6 input-min-height"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Billing name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Billing name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Billing name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full d-flex align-items-center mb-0"
  }, [_c('span', [_vm._v("VAT number")]), _vm._v(" "), (_vm.getHasInvoiceSystem && !_vm.form.vat) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Required to create invoices'),
      expression: "'Required to create invoices'"
    }],
    staticClass: "fas fa-exclamation-triangle color-4 fs-smallest ml-1"
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.vat),
      expression: "form.vat"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "vat", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12 mb-2"
  }, [_c('label', {
    staticClass: "full d-flex align-items-center"
  }, [_c('span', [_vm._v("Address")]), _vm._v(" "), (_vm.getHasInvoiceSystem && !_vm.form.address) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Required to create invoices'),
      expression: "'Required to create invoices'"
    }],
    staticClass: "fas fa-exclamation-triangle color-4 fs-smallest ml-1"
  }) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "w-100",
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mb-5"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("ZIP Code\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zip),
      expression: "form.zip"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Location\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.location),
      expression: "form.location"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "location", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full mb-0"
  }, [_vm._v("Country")]), _vm._v(" "), _c('country-picker', {
    attrs: {
      "openDirection": 'bottom',
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.showFeatureScheduleTasks) ? _c('h5', [_vm._v("Schedule Tasks")]) : _vm._e(), _vm._v(" "), (_vm.showFeatureScheduleTasks) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.isWorkflowAllowedToSendEmails),
      callback: function($$v) {
        _vm.$set(_vm.form, "isWorkflowAllowedToSendEmails", $$v)
      },
      expression: "form.isWorkflowAllowedToSendEmails"
    }
  }, [_vm._v("\n                                Allow sending automatic emails\n                            ")])], 1)]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "mt-4"
  }, [_vm._v("Reports")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.isToHideReportCalculations),
      callback: function($$v) {
        _vm.$set(_vm.form, "isToHideReportCalculations", $$v)
      },
      expression: "form.isToHideReportCalculations"
    }
  }, [_vm._v("\n                                Hide page that explains all the calculations.\n                            ")])], 1)])])])]), _vm._v(" "), (!_vm.getSelectedPerson) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-1 p-2"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "submit",
      "value": "Next",
      "disabled": _vm.$v.form.$invalid || _vm.$v.businessTypeId.$invalid
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "m-0"
  }, [_vm._v("Name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab6fa62"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentForm.vue
// module id = 1216
// module chunks = 0